import { Pill } from "./ui.tsx";
import { STATUS_LABEL, type InitiativeStatus } from "../../shared/planning.ts";

const tone: Record<InitiativeStatus, "gray" | "blue" | "gold" | "green"> = {
  draft: "gray",
  in_review: "blue",
  changes_requested: "gold",
  validated: "green",
};

export function StatusPill({ status }: { status: InitiativeStatus }) {
  return <Pill tone={tone[status]}>{STATUS_LABEL[status]}</Pill>;
}

/** Axis color always travels with its text, never alone (docs/06). */
export function AxisTag({ name, color }: { name: string; color: string }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-semibold">
      <span className="size-2.5 rounded-full" style={{ background: color }} aria-hidden />
      {name}
    </span>
  );
}
